<div class="navigation-items action-items navigation-border-right">
  <div class="action-icon" (click)="setSearchBarVisibility()">
    <svg-icon src='./assets/icons/search-outline.svg' alt="SEARCH" title="{{'projectToolbar.search' | translate | uppercase}}" class="menu-action-icon svg-icon-gray"
              align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.search' | translate | uppercase}}</div>
  </div>
  <div *ngIf="searchTabVisible" class="action-icon" (click)="triggerAction('resetComparablesSearchForm')">
    <svg-icon src='./assets/icons/showAll.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.showAll' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.showAll' | translate | uppercase"></div>
  </div>
  <div *ngIf="isAPT && selectedTab === activeTab.Properties" class="action-icon"
       (click)="openNewTabAndTriggerAction('newPropertyFromNav','comparablesTabSelect', 'tabProperty')">
    <svg-icon src='./assets/icons/add_new.svg' class="menu-action-icon svg-icon-gray"
              title="{{'comparablesToolbar.buttonNewProperty' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'comparablesToolbar.buttonNewProperty' | translate | uppercase"></div>
  </div>
  <div *ngIf="isAPT && selectedTab === activeTab.Valuations" class="action-icon"
       (click)="openNewTabAndTriggerAction('createValuationsDataFromNav','comparablesTabSelect', 'tabValuation')">
    <svg-icon src='./assets/icons/add_new.svg' class="menu-action-icon svg-icon-gray"
              title="{{'comparablesToolbar.buttonNewValuation' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'comparablesToolbar.buttonNewValuation' | translate | uppercase"></div>
  </div>
  <div *ngIf="isAPT && selectedTab === activeTab.Leases" class="action-icon"
       (click)="openNewTabAndTriggerAction('createLeaseTransactionDataFromNav','comparablesTabSelect', 'tabLeases')">
    <svg-icon src='./assets/icons/add_new.svg' class="menu-action-icon svg-icon-gray"
              title="{{'comparablesToolbar.buttonNewLease' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'comparablesToolbar.buttonNewLease' | translate | uppercase"></div>
  </div>
  <div *ngIf="isAdminUser" class="action-icon" (click)="!formOpened && triggerAction('buttonDeleteComp')" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/delete.svg' class="menu-action-icon svg-icon-gray"
              title="{{'comparablesToolbar.buttonDelete' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'comparablesToolbar.buttonDelete' | translate | uppercase}}</div>
  </div>
</div>
<div class="navigation-items action-items navigation-border-right">
  <div *ngIf="selectedTab === activeTab.Properties" class="action-icon"
       (click)="setinfoBarVisibilityComparables()">
    <svg-icon src='./assets/icons/searchInfoMode_please_rotate_accordingly.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.buttonInfoMode' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonInfoMode' | translate | uppercase"></div>
  </div>
  <div *ngIf="formOpened" class="action-icon" (click)="saveCancelActionsClicked(true)" [class.disabled]="saveInProgress">
    <svg-icon src='./assets/icons/save.svg' class="menu-action-icon svg-icon-gray"
              title="{{'comparablesToolbar.buttonSave' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'comparablesToolbar.buttonSave' | translate | uppercase}}</div>
  </div>
  <div *ngIf="formOpened" class="action-icon" (click)="displayFullNavigation()">
    <svg-icon src='./assets/icons/close-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.cancel' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.cancel' | translate | uppercase}}</div>
  </div>
</div>
<div class="navigation-items action-items">
  <div *ngIf="isAPT" class="action-icon" (click)="!formOpened && triggerAction('buttonImport')" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/upload_import.svg' class="menu-action-icon  svg-icon-gray"
              title="{{'projectToolbar.buttonImport' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.buttonImport' | translate | uppercase}}</div>
  </div>
  <div class="action-icon" (click)="!formOpened && triggerAction('buttonExport')" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/download_export.svg' class="menu-action-icon  svg-icon-gray"
              title="{{'projectToolbar.buttonExport' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.buttonExport' | translate | uppercase}}</div>
  </div>
  <div *ngIf="isAPT" class="action-icon" (click)="!formOpened && triggerAction('buttontemplateComp')" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/createTemplate.svg' class="menu-action-icon  svg-icon-gray"
              title="{{'projectToolbar.buttonTemplate' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonTemplate' | translate | uppercase"></div>
  </div>
</div>
